<template>
  <div id="modal_popup_offer" class="modal-popup">
    <div class="modal-popup-content">
      <a @click="showModalPopup('modal_popup_offer', false)" class="close-button">
        <img src="@/assets/images/close-button.svg" />
      </a>
      <div class="d-inline-block" v-if="this.offer">
        <div class="offer-details-wrapper">
          <div class="offer-discount d-flex align-items-center justify-content-center">
            {{ this.discountValueLabel }}
          </div>
          <div v-if="this.image" class="offer-preview-image" :style="{ 'background-image': `url(${this.image})` }"></div>
          <div v-else class="offer-preview-image"
            :style="{ 'background-image': `url(${this.getImagePath() + 'offers/offer_' + this.offer.id + '.png'})` }">
          </div>

          <!-- <img v-if="!this.image" class="offer-image" :src="
            this.getImagePath() + 'offers/offer_' + this.offer.id + '.png' -->

          <!-- " @error="($event.target.src = require('@/assets/images/offer_0.svg'))" /> -->
          <h5>{{ this.offer.name }}</h5>
          <div class="offer-price">
            {{ (this.offer.price + " " + this.offer.currency) }}
          </div>
          <p class="description">{{ this.offer.description }}</p>
          <div class="contact-details-wrapper">
            <div>
              <div v-if="this.offer.type.toLowerCase() !== 'offer'" class="text">
                <img class="width-32" :src="require('@/assets/images/location.svg')" />
                <p>{{ $t("locationValueLabel") }}</p>
                <p class="user-added">
                  {{ this.offer.location }}
                </p>
              </div>
              <div class="text">
                <img class="square-32 border-round" :src="this.getImagePath() +
                  'users/user_' +
                  this.offer.person.id +
                  '.png'
                  " @error="($event.target.src = require('@/assets/images/offer_0.svg'))" w />
                <p>{{ $t("addedByLabel") }}</p>
                <p class="user-added">
                  {{
                    this.offer.person.first_name +
                    " " +
                    this.offer.person.last_name
                  }}

                </p>
                <br clear="all" />
                <p>
                  {{
                    this.offer.person.company_name
                  }}
                </p>
              </div>
              <div class="text">
                <img class="width-32" :src="require('@/assets/images/location.svg')" />
                <p>{{ $t("cityLabel") }}</p>
                <p class="user-added">
                  {{ this.offer.city }}
                </p>
              </div>
            </div>

            <div>
              <div v-if="this.offer.type.toLowerCase() !== 'offer'" class="text">
                <img :src="require('@/assets/images/calendar.svg')" />
                <p v-html="$t('periodLabel', {
                      start_date: formatDate(
                        this.offer.startDate
                          ? this.offer.startDate
                          : this.period.startDate[0],
                        'DD/MM/yyyy',
                        'YYYY-MM-DDThh:mm:ss'
                      ),
                      end_date: formatDate(
                        this.offer.endDate ? this.offer.endDate : this.period.endDate[0],
                        'DD/MM/yyyy',
                        'YYYY-MM-DDThh:mm:ss'
                      ),
                    })
                    " />
              </div>
              <div class="text">
                <img :src="require('@/assets/images/calendar.svg')" />
                <p v-html="$t('valabilityLabel', {
                      start_date: formatDate(
                        this.offer.validity_start_date
                          ? this.offer.validity_start_date
                          : this.period.validity_start_date[0],
                        'DD/MM/yyyy',
                        'YYYY-MM-DDThh:mm:ss'
                      ),
                      end_date: formatDate(
                        this.offer.validity_end_date
                          ? this.offer.validity_end_date
                          : this.period.validity_end_date[0],
                        'DD/MM/yyyy',
                        'YYYY-MM-DDThh:mm:ss'
                      ),
                    })
                    " />
              </div>
              <PersonContactOnly :person="this.offer.person" :user="this.user" :offerName="this.offer.name" :offerId="this.offer.id" />
            </div>
            <!-- <div>
              <div>
                &nbsp;
              </div>
              <br />

             
            </div> -->

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PersonContactOnly from "@/components/fragments/PersonContactOnly.vue";

export default {
  name: "OfferDetailsPopup",
  components: { PersonContactOnly },

  props: {
    user: Object,
    offer: Object,
    image: String,
    isDiscount: Boolean,
    discountValue: Number,
    offerType: String,
    currency: String,
    period: Object,
  },
  data() {
    return {
      // offer: null,
    };
  },
  methods: {
    getOfferDetails() { },
  },
  computed: {
    discountValueLabel: function () {
      if (this.offer.id > 0) {
        return (
          "-" +
          (this.offer.discount > 0
            ? this.offer.discount + "%"
            : this.offer.deduction + "" + this.offer.currency)
        );
      } else {
        return (
          "-" +
          this.discountValue +
          (this.isDiscount ? "%" : "" + this.currency)
        );
      }
    },
  },
};
</script>
<style scoped src="@/assets/styles/beneficiary.css"></style>
<style scoped>
.position {
  position: relative;
  left: 227px;
}
.contact-details-wrapper{
  justify-content: space-evenly;
}
</style>
